<template>

  <section class="py-12 bg-gray-800">
    <div class="container text-center">
      <h1 class="text-white text-xl leading-tight">
        <div class="!leading-none text-blue-500 text-3xl md:text-4xl font-bold">Theaterfreude sichern</div>
        <div class="!leading-none mt-2">mit unseren DAS DA-Abos</div>
      </h1>
    </div>
  </section>

  <section v-if="sections.length" class="py-24 space-y-24">
    <div v-for="section in sections" :id="section.id" :key="section.id">
      <div class="container max-w-[740px]" >
        <div class="text text-center text-lg" v-html="section.description"></div>
      </div>
      <div class="container max-w-3xl">
        <Coupons
          :headline="null"
          :items="section.items"
          class="mt-12"
        />
      </div>
    </div>
  </section>

  <Empty v-else text="Keine Abos verfügbar" />

  <section class="bg-gradient-to-r from-blue-500 to-blue-accent py-16 my-8">
    <div class="container max-w-3xl text-center xl:flex xl:text-left items-center">
      <div class="text text-lg font-semibold text-white">
        <p>Mit unseren Abos können Sie sich bereits zwei Wochen vor dem offiziellen Vorverkaufsstart einen Termin und Platz sichern und sparen im Vergleich zum regulären Ticketpreis.</p>
        <p>Sie sind nicht personengebunden und enden automatisch nach Ablauf der Spielzeit.</p>
      </div>
      <div class="hidden flex-none xl:block w-[376px] -mr-60 -my-[30%] ml-12">
        <img
          src="/media/Plakatmotive_2526_3er-Abo.png"
          alt="Plakatmotive Spielzeit 2024-2025"
        >
      </div>
    </div>
  </section>

  <section class="py-20">
    <div class="container">
      <div class="text-center pb-20">
        <h2 class="text-lg sm:text-2xl">Häufig gestellte Fragen</h2>
        <div class="text-3xl sm:text-4xl text-blue-500 font-bold">FAQ</div>
      </div>
      <div class="mx-auto max-w-md md:max-w-full grid md:grid-cols-2 gap-y-16 gap-x-12">

        <div class="text">
          <h3 class="text-blue-500">Kann ich auswählen, welche Stücke in meinem Abo enthalten sind?</h3>
          <p>Leider nein. Bei der Planung der Spielzeit legen wir fest, welche Stücke wir Ihnen im Abonnement anbieten. Sie können aber zwischen verschiedenen Abo-Varianten wählen. Unser reguläres 3er-Abo fokussiert sich auf unsere Eigenproduktionen. Eine erweiterte Form ist das 4er-Abo, das zusätzlich ein weiteres Stück enthält z. B. ein Gastspiel. Eine Übersicht der in der aktuellen Spielzeit verfügbaren Abos finden Sie oben. Unser Miniabo enthält die letzten beiden Stücke der jeweiligen Spielzeit. Auf den Produktseiten sowie auf Ihrer gekauften Abo-Karte sind außerdem die im jeweiligen Abo enthaltenen Stücke gelistet. </p>
        </div>

        <div class="text">
          <h3 class="text-blue-500">Was ist der Unterschied zwischen einem 3er-, 4er- und Miniabo?</h3>
          <p>Das 3er-Abo ist unser reguläres Abonnement und in jeder Spielzeit verfügbar. Es enthält je ein Ticket für zwei Schauspiel-Produktionen und unser Open-Air-Musical. Das 4er-Abo ist ein zusätzliches Produkt, mit dem Sie insgesamt vier Stücke vergünstigt sehen können, z. B. die Wiederaufnahme eines Stücks der vorherigen Spielzeit oder ein Gastspiel der aktuellen Spielzeit. Das 4er-Abo ist nicht in jeder Spielzeit verfügbar. Von Dezember bis Februar bieten wir mit dem Miniabo unser kleines Abonnement an. Mit diesem sind Sie bei unseren letzten beiden Stücken der jeweiligen Spielzeit dabei: einem Schauspiel und dem Open-Air-Musical.</p>
        </div>

        <div class="text">
          <h3 class="text-blue-500">Was ist der Unterschied zwischen Platzgruppe A und B?</h3>
          <p>Wir bieten Ihnen Abos für die Platzgruppe A und die Platzgruppe B an. Auf Burg Wilhelmstein unterscheiden wir dabei zwischen überdachten und nicht-überdachten Sitzplätzen. Bei uns an der Liebigstraße befinden sich die Plätze der Gruppe A grundsätzlich zentrierter zur Bühne, während sie von den Plätzen der Gruppe B eingerahmt werden. Die Sicht auf die Bühne ist von allen Sitzen uneingeschränkt.</p>
        </div>

        <div class="text">
          <h3 class="text-blue-500">Wie kann ich mein Abo einlösen?</h3>
          <p>Mit Ihrer individuellen Abo-Nummer können Sie sich ab zwei Wochen vor dem offiziellen Vorverkaufsstart Ihre Theaterkarten sichern. Dafür können Sie unseren Onlineshop nutzen, oder Sie kommen persönlich an einer unserer Vorverkaufsstellen vorbei. Wie auch immer Sie sich entscheiden, Sie haben beim Einlösen Ihres Abos die Möglichkeit, unter den noch verfügbaren Plätzen Ihren Wunschplatz auszuwählen.</p>
        </div>

        <div class="text">
          <h3 class="text-blue-500">Kann ich die Platzgruppe wechseln?</h3>
          <p>Beim Kauf entscheiden Sie sich für ein Abonnement der Platzgruppe A oder B. Bei der Sitzplatzbuchung können Sie daher also einen Platz aus der jeweiligen Gruppe auswählen. Für Abonnenten der Preisgruppe B ist es möglich, gegen Zahlung der Preisdifferenz auch einen Platz in der Gruppe A zu wählen. Sollten Sie ein Abo der Platzgruppe A besitzen und auf einen Platz in der Gruppe B wechseln wollen, ist eine Rückerstattung der Differenz leider nicht möglich. Bitte beachten Sie: Ab dem Start des freien Vorverkaufs gibt es keine Gewähr für Plätze.</p>
        </div>

        <div class="text">
          <h3 class="text-blue-500">Für wen gilt ein ermäßigtes Abo?</h3>
          <p>Grundsätzlich erhalten Schüler*innen, Studierende und Auszubildende bis 29 Jahre, Arbeitslose und Sozialhilfeempfänger*innen (Aachen-Pass) sowie Menschen mit einem Grad der Behinderung (GdB) von mindestens 50 bei uns ermäßigte Tickets – und somit auch Abos. Menschen, die mit ihrem Ausweis eine Berechtigung zur Mitnahme einer Begleitperson haben, erhalten neben ihrer eigenen Ermäßigung eine Freikarte für ihre fachliche Begleitung bzw. ein ermäßigtes Ticket für eine nicht-fachliche Begleitung. Alle hier gelisteten Personen müssen beim Einlass ihren jeweiligen Ermäßigungsnachweis vorzeigen.</p>
        </div>

      </div>
    </div>
  </section>

</template>

<script>
import Layout from 'Web/Layouts/WithCart.vue';
import Button from 'Web/Shared/Button.vue';
import Coupons from 'Web/Shared/Coupons.vue';
import Empty from 'Web/Shared/Empty.vue';
import Header from 'Web/Shared/Header.vue';
import UpcomingCoupon from 'Web/Shared/UpcomingCoupon.vue';
import useMeta from '@/compose/meta';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    UpcomingCoupon,
    Button,
    Coupons,
    Empty,
    Header,
  },
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop - Abos' });
  }
}
</script>
